import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Lenis from "lenis";

export const LenisRoot = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduced) return undefined;

    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  // Lenis keeps its scroll position across route changes; reset gently.
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};
